// Shared axios instance for the agent service. Mirrors src/services/api.ts:
// baseURL /api/v1, Bearer token from session/local storage, withCredentials,
// 401 -> cross-tab logout. Re-exported so agentApi and the proposal-execution
// path use the same RBAC/audited admin REST calls.

import axios from 'axios';
import * as sessionStore from './sessionStore';
import { refreshActiveSession, dropActiveSessionAndRedirect } from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = sessionStore.getActiveAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = (error.config ?? {}) as any;
    if (error.response?.status === 401) {
      // Captured BEFORE the refresh await — see api.ts: prevents concurrent
      // 401s from cascade-dropping accounts promoted after the first drop.
      const failedId = sessionStore.getActiveMemberId();
      if (!original._retry) {
        original._retry = true;
        const token = await refreshActiveSession();
        if (token) {
          original.headers = original.headers ?? {};
          original.headers.Authorization = `Bearer ${token}`;
          return api(original);
        }
      }
      dropActiveSessionAndRedirect(failedId);
      return Promise.reject(error);
    }
    if (!error.response) {
      error.message = 'Помилка мережі. Перевірте підключення до інтернету.';
    }
    if (error.response?.status >= 500) {
      error.message = 'Помилка сервера. Спробуйте пізніше.';
    }
    return Promise.reject(error);
  }
);

export default api;
